import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function ExperimentsIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <g stroke="currentColor" strokeWidth="1.5">
        <path
          d="M2.205 14.761 6.211 9.09V3.33c0-.735.596-1.33 1.33-1.33h4.614c.735 0 1.33.595 1.33 1.33v5.759l4.31 5.672a1.464 1.464 0 0 1 .004 1.486 1.511 1.511 0 0 1-.554.547c-.23.132-.492.203-.76.206H3.515a1.562 1.562 0 0 1-.76-.206 1.512 1.512 0 0 1-.554-.547 1.463 1.463 0 0 1 .004-1.486Z"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M5 11.339C9.555 13.694 10.343 9 13 9" />
      </g>
    </Icon>
  );
}
